import { render, staticRenderFns } from "./OnboardingChecklist.vue?vue&type=template&id=6d535406&scoped=true&"
import script from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingChecklist.vue?vue&type=style&index=0&id=6d535406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d535406",
  null
  
)

export default component.exports